import { useFloating as s, flip as f, shift as i, offset as l, autoUpdate as p } from "@floating-ui/react-dom";
const r = 10, d = ({
  flipOptions: t,
  shiftOptions: o,
  floatingOptions: e,
  offset: a = r,
  customMiddlewares: n = []
}) => s({
  whileElementsMounted: p,
  middleware: [
    f(t),
    i(o),
    l(a),
    ...n
  ],
  ...e
});
export {
  d as u
};
